 <app-header></app-header> 

<!-- Start Learning Pannel Start -->
<section id="start-learning-pannel">
  <div class="sl-wrapper">
    <div class="row m-hide">
      <div class="col-12 col-md-12 col-lg-4 text-center m-hide rht-img">

      </div>
      <div class="col-12 col-md-12 col-lg-8 text-center">
        <div class="sl-inner-txt" (click)="$event.stopPropagation();">
          <h1>Aage ka Kya<br> Socha <span class="badge badge-danger">Hai !</span></h1>
          <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="form-wrapper">
            <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaForm">
              <div class="form-group">
                <form [formGroup]="sriChaitanyaStartForm" class="admission-number-input-form">
                  <input [maxlength]="SCMaxLength" formControlName="admissionNumber"  [placeholder]="SCPlaceHolder"
                    class="form-control admission-number-input">
                  <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm.value)"
                    [disabled]="!sriChaitanyaStartForm.valid" type="button"
                    class="btn btn-primary btn-danger">START LEARNING</button>
                </form>
              </div>
            </ng-container>
            <ng-template #notSrichaitanyaForm>
              <form method="POST">
                <app-common-mobile-number id="StartLearningMobileInput" (mobileNumberChange)="doSearch($event)"
                  (keyup.enter)="enterKey($event, 1)" (keyup.escape)="escapeKey($event)" (callSignUp)="signup(1, searchValue)">
                </app-common-mobile-number>
              </form>
            </ng-template> 
          </div>
          <div class="d-flex justify-content-center IL_sc-click font-weight-bold assessment_mt-10">
            <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
              <ng-template #others>
                <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
              </ng-template>
        </div>
        </div>
      </div>
    </div>
    <div class="row m-show" (click)="$event.stopPropagation();">
      <div class="col-12 col-md-12 col-lg-8 text-center">
        <div class="sl-inner-txt">
          
          <figure class="m-show">
            <img src="assets/img/ilite-homebg-mobile.jpg" alt="" class="img-fluid">
          </figure>
          <h1>Aage ka Kya<br> Socha <span class="badge badge-danger">Hai !</span></h1>
          <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="form-wrapper">
            <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaForm">
              <div class="form-group">
                <form [formGroup]="sriChaitanyaStartForm" class="admission-number-input-form">
                  <input [maxlength]="SCMaxLength" formControlName="admissionNumber" [placeholder]="SCPlaceHolder"
                    class="form-control admission-number-input">
                  <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm.value)"
                    [disabled]="!sriChaitanyaStartForm.valid " type="button"
                    class="btn btn-primary btn-danger">START LEARNING</button>
                </form>
              </div>
            </ng-container>
            <ng-template #notSrichaitanyaForm>
              <form method="POST">
                <app-common-mobile-number id="StartLearningMobileInput" (mobileNumberChange)="doSearch($event)"
                  (keyup.enter)="enterKey($event, 1)" (keyup.escape)="escapeKey($event)" (callSignUp)="signup(1, searchValue)">
                </app-common-mobile-number>
              </form>
            </ng-template>
          </div>
          <div class="d-flex justify-content-center IL_sc-click font-weight-bold assessment_mt-10">
            <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
              <ng-template #others>
                <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
              </ng-template>  
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-4 text-center m-hide rht-img">
        <figure>
          <img src="assets/img/homeimage2.png" alt="" class="img-fluid">
        </figure>
      </div>
    </div>
  </div>
</section>
<!-- Start Learning Pannel End -->

<!-- il-neet key section start -->
<section *ngIf="portal != 'SCORE'" class="ilneetkey-sec">
  <div class="container-fluid">
      <div class="row">
          <div class="col-md-6 col-sm-12">
             <div class="il-neetkey">
                <a href="https://srichaitanya.net/neet2021-solutions"  target="_blank"><strong>NEET 2021</strong> - Question Paper, Key & Solutions (Sep 12th) </a>
              </div>
          </div>
          <div class="col-md-6 col-sm-12">
              <div class="il-neetkey" [formGroup]='rankPredictForm'>
                <span>NEET Rank Predictor <input type="number" formControlName='neetMarks' max-length="3" placeholder="Enter NEET Marks"> <input type="button" [disabled]='!rankPredictForm.valid' class="rank-btn" (click)='predictRank()' value="Predict Rank"></span>
              </div>
          </div>
      </div>
  </div>
</section>
<!-- il-neet key section end -->
<!-- Our Courses Section Start -->
<section id="our-courses-pannel">
  <div class="container">
    <div class="row">
      <div class="col-12">
          <div class='embed-container'>
            <iframe src='https://www.youtube.com/embed/-Gf68vAf0LA' frameborder='0' allowfullscreen></iframe>
          </div>
        
      </div>
    </div>
  </div>
</section>
<!-- Our Courses Section End -->
<!-- Our Courses Section Start -->
<section id="our-courses-pannel">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="title-box">
          <h2 class="h2">Our <span>Courses</span></h2>
        </div>
        <div class="cource-combo-box">
          <div class="c-box-inner">
            <div class="c-box-inner-left neet-box">
              <h3>NEET</h3>
              <img src="assets/img/neet-small-img.svg" alt="" class="img-fluid">
            </div>
            <div class="c-box-inner-right">
              <p>Assure your success in NEET. A comprehensive learning program to crack the exam. Result oriented Live
                Classes, Test
                Series, Mock test and Previous year papers specially crafted by top educators</p>
              <button type="button" class="btn-explore" routerLink="/neet">Explore More</button>
            </div>
          </div>
          <div class="c-box-inner">
            <div class="c-box-inner-left jee-box">
              <h3>JEE</h3>
              <img src="assets/img/jee-small-img.svg" alt="" class="img-fluid">
            </div>
            <div class="c-box-inner-right">
              <p>Assess your preparation as compared to others. Step up your preparation and improve your rank with our
                Test series, Mock test and Previous year papers.</p>
              <button type="button" class="btn-explore" routerLink="/jee">Explore More</button>
            </div>
          </div>
        </div>
        <!-- <div class="courses-box-wrapper">
          <div class="courses courses-1" routerLink="/neet">
            <h3>NEET</h3>
            <p>Assure your success in NEET <span>A comprehensive learning program to crack the exam</span></p>
          </div>
          <div class="courses courses-2" routerLink="/jee">
            <h3>JEE</h3>
            <p>Ace your JEE preparation. <span>Learn from highly experienced faculty</span></p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</section>
<!-- Our Courses Section End -->

<!-- Why choose us section Start -->
<section id="why-choose-us-pannel">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h2 class="h2">Wondering why you should <span>Choose Us?</span></h2>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-6 col-lg-3">
        <div class="box">
          <figure>
            <img src="assets/img/Expert-Faculty-icon-dark.svg" alt="">
          </figure>
          <p>Expert Faculty from <span>Sri Chaitanya</span></p>
        </div>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
        <div class="box">
          <figure>
            <img src="assets/img/Adaptive-Practice-icon-dark.svg" alt="">
          </figure>
          <p><span>Adaptive</span> <span>Practice</span></p>
        </div>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
        <div class="box">
          <figure>
            <img src="assets/img/Personalised-Learning-icon-dark.svg" alt="">
          </figure>
          <p> <span> Personalised</span> <span>Learning</span></p>
        </div>
      </div>
      <div class="col-6 col-md-6 col-lg-3">
        <div class="box">
          <figure>
            <img src="assets/img/Performance-Analysis-icon-dark.svg" alt="">
          </figure>
          <p>Performance <span>Analysis</span></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Why choose us section End -->

<!-- Our Expert Team Section start -->
<section id="expert-team-pannel">

  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="h2">Our <span>Expert Faculty</span></h2>

        <!-- Slider Start -->
        <div id="coverflow" class="teachers-slider-wrapper" (window:scroll)='onFacultyView()'>
          <ul class="slide-wrap">
            <li class="chemistry-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="aman-bg">
                    <img src="assets/img/aman_kumar.png" alt="Aman Kumar" />
                  </figure>
                  <div class="text">
                    <div class="m-title aman-title">
                      <h4>Aman Kumar</h4>
                    </div>
                    <p>Aman Kumar Varma, B.E Chemical Engineer from Sir Visvesvaraya Institute of Technology, Nashik,
                      having 8+ years of experience in teaching Organic Chemistry for JEE Mains and NEET. </p>
                  </div>
                </div>
              </div>
            </li>
            <li class="mathematics-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="basheer-bg">
                    <img src="assets/img/basheer_shaik.png" alt="Basheer Shaik" />
                  </figure>
                  <div class="text">
                    <div class="m-title basheer-title">
                      <h4>Basheer Shaik</h4>
                    </div>
                    <p>Basheer Shaik is a double gold medallist, B.Ed with master’s degree in Mathematics and has 15+
                      years of teaching experience. He has taught top batches and produced many single and double digit
                      ranks such as AIR 5, AIR 18, AIR 118 in JEE Mains and JEE Advanced.</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="botony-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="kiran-bg">
                    <img src="assets/img/kiran_chowdry.png" alt="Vani Manohar" />
                  </figure>
                  <div class="text">
                    <div class="m-title kiran-title">
                      <h4>Kiran Choudhary</h4>
                    </div>
                    <p>Kiran Choudhary has 5+ years of teaching Botany and has mentored over 5000 students. With M.Sc.
                      from MDS University, she has produced top ranks with students securing admissions into AIIMS and
                      SMS Medical College.</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="chemistry-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="sanjib-bg">
                    <img src="assets/img/ayushi.png" alt="Ayushi" />
                  </figure>
                  <div class="text">
                    <div class="m-title sanjib-title">
                      <h4>Ayushi Agarwal</h4>
                    </div>
                    <p>Ayushi Agarwal, botany expert with an experience of more than 5 years, has completed her masters in Botany from
                      Banaras Hindu University. She has produced many top AIRs with many of my students pursuing MBBS from colleges such as
                      AIIMS, Maulana Azad and many more.</p>
                  </div>
                </div>
              </div>
            </li>
            <li class="zoology-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="suchita-bg">
                    <img src="assets/img/suchita.png" alt="Suchita" />
                  </figure>
                  <div class="text">
                    <div class="m-title suchita-title">
                      <h4>Suchita</h4>
                    </div>
                    <p>Suchita has over 8 years of experience in teaching and content development. She has coached
                      thousands of students resulting in several of her students securing admission into medical
                      colleges such as AIIMS, JIPMER, and AFMC. </p>
                  </div>
                </div>
              </div>
            </li>

            <li class="physics-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="supreet-bg">
                    <img src="assets/img/supreet_singh.png" alt="Supreet Singh" />
                  </figure>
                  <div class="text">
                    <div class="m-title supreet-title">
                      <h4>Supreet Singh</h4>
                    </div>
                    <p>Supreet Singh, B.Tech in Electronics & Communication and M.Tech in Electronics, has 9 + years of
                      experience in teaching Physics for both JEE and NEET students. He has mentored more than 5000
                      students in both online and offline classes and produced multiple all India ranks. </p>
                  </div>
                </div>
              </div>
            </li>

            <li class="biology-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="swagata-bg">
                    <img src="assets/img/swagata_mukherjee.png" alt="Swagata Mukherjee" />
                  </figure>
                  <div class="text">
                    <div class="m-title swagata-title">
                      <h4>Swagata Mukherjee</h4>
                    </div>
                    <p>Swagata Mukherjee, M.Sc. from Bangalore University and master’s degree in Applied Genetics, has
                      6+ years of experience in teaching Zoology and has taught top batches to produce numerous double
                      digit ranks and many selections in AIIMS, AFMC and IISER. </p>
                  </div>
                </div>
              </div>
            </li>

            <li class="physics-background">
              <div class="inner">
                <div class="inner-content">
                  <figure class="vibati-bg">
                    <img src="assets/img/vibati_jain.png" alt="Vibhati Jain" />
                  </figure>
                  <div class="text">
                    <div class="m-title vibati-title">
                      <h4>Vibhati Jain</h4>
                    </div>
                    <p>Vibhati Jain has 5 years of extensive experience in coaching 10000+ students. Her students have
                      secured 99%ile and 100%ile across NEET and IIT-JEE. She has also coached students from 10
                      countries other than India. </p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- Slider End -->

      </div>
    </div>
  </div>
</section>
<!-- Our Expert Team Section End -->

<!-- Ready Start Learning Section Start -->
<section id="ready-start-learning-pannel">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-5 text-right m-hide">
        <figure>
          <img src="assets/img/devices-il.png" alt="infinity Learn" />
        </figure>
      </div>
      <div class="col-sm-12 col-md-7">
        <h2 class="h2">Ready to start learning with us?</h2>
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 text-center">
            <div [class.srichaitanya-tenant]="tenant=='srichaitanya'" class="form-wrapper">
              <ng-container *ngIf="tenant=='srichaitanya';else notSrichaitanyaForm">
                <div class="form-group">
                  <form [formGroup]="sriChaitanyaStartForm1" class="admission-number-input-form">
                    <input [maxlength]="SCMaxLength" formControlName="admissionNumber"  [placeholder]="SCPlaceHolder"
                       class="form-control admission-number-input">
                    <button (click)="openAdmissionLoginForm(sriChaitanyaStartForm1.value)"
                      [disabled]="!sriChaitanyaStartForm1.valid " type="button"
                      class="btn btn-primary btn-danger">START LEARNING</button>
                  </form>
                </div>
              </ng-container>
              <ng-template #notSrichaitanyaForm>
                <app-common-mobile-number (mobileNumberChange)="doSearch($event)" (keyup.enter)="enterKey($event, 2)"
                  (keyup.escape)="escapeKey($event)" (callSignUp)="signup(2, searchValue)">
                </app-common-mobile-number>
              </ng-template>

            </div>
            <div class="d-flex justify-content-center IL_sc-click white font-weight-bold assessment_mt-10">
              <span *ngIf="tenant == 'srichaitanya';else others">Forgot Password? - <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">Click Here</span></span>
              <ng-template #others>
                <span>Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
              </ng-template>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Ready Start Learning Section End -->

<!-- Both Students & Parents Love us Section Start -->
<section id="student-parents-love-pannel">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h2 class="h2">Why students <span>Love us</span></h2>
        <div class="sp-slider-wrapper">
          <ul class="sp-slider-list">
            <li>
              <div class="s-info neet">
                <figure>
                  <img src="assets/img/Snikitha-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>Snikitha Tummala</h4>
                    <p>NEET 2020 <span>AIR 3</span></p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>This dream would never have
                  been true without the help of my parents and teachers at Sri Chaitanya. My success mantra for
                  achieving this goal and that is all what makes you lucky on the day of the exam. </p>
              </div>
            </li>
            <li>
              <div class="s-info neet">
                <figure>
                  <img src="assets/img/Chaitanya-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>Chaitanya Sindhu</h4>
                    <p>NEET 2020 <span>AIR 6</span></p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>I was interested in
                  joining one the best NEET Coaching and believed that Sri Chaitanya is the best choice. Their
                  techniques, material and completely organized structure helped me to move along the right path. </p>
              </div>
            </li>
            <li>
              <div class="s-info jee">
                <figure>
                  <img src="assets/img/Sunil Kumar-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>Sunil Kumar Vishwesh </h4>
                    <p>JEE Main 2020 <span>AIR 1 </span></p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>Sri Chaitanya, my faculty and to my parents who supported throughout the preparation. Daily
                  homework, Series on <strong>online tests</strong>, <strong>micro analysis</strong> and Consistent hard
                  work leads me to success. </p>
              </div>
            </li>
            <li>
              <div class="s-info jee">
                <figure>
                  <img src="assets/img/Bhuvan Reddy-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>G. Bhuvan Reddy</h4>
                    <p>JEE Advanced 2020 <span>AIR 2</span> </p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>I am extremely happy about my success. I have really worked hard in these 3 years and finally got the
                  fruit of my hard work. My parents supported me throughout and Sri Chaitanya also guided me through its
                  study material and tests. </p>
              </div>
            </li>
            <li>
              <div class="s-info jee">
                <figure>
                  <img src="assets/img/Landa Jitendra-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>Landa Jitendra</h4>
                    <p>JEE Main 2020 <span>AIR 4</span> </p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>My JEE Main AIR is 4. Sri Chaitanya faculty members and staff, my parents
                  have greatly supported me at my preparation. I always completed my homework and also revised the test
                  taken many times. I would suggest struggle till the exam is not cleared. </p>
              </div>
            </li>
            <li>
              <div class="s-info jee">
                <figure>
                  <img src="assets/img/Shashank-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>R Shashank Anirudh</h4>
                    <p>JEE Main 2020 <span>AIR 7</span></p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>I am a proud student of Sri Chaitanya which guided me in achieving success in NEET Entrance Exam.
                  This goal would not have been reachable if it were not for my teachers at Sri Chaitanya and so I give
                  the credit for my success to all the faculty. </p>
              </div>
            </li>
            <li>
              <div class="s-info jee">
                <figure>
                  <img src="assets/img/Dhvani-100.png" alt="Image">
                </figure>
                <div class="s-info-rht d-flex align-items-center">
                  <div class="in-content">
                    <h4>Dhvanit Beniwal</h4>
                    <p>JEE Advanced 2020 <span>AIR 10</span></p>
                  </div>
                </div>
              </div>
              <div class="s-info-bottom">
                <p>My journey with Sri Chaitanya started 3 years ago. It has been the most amazing experience studying
                  in Chaitanya. I gained a lot of experience like how to cope up with different situations in life. The
                  teaching faculty has really helped in <strong>clearing my doubts</strong> and strengthening my
                  concepts. </p>
              </div>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Both Students & Parents Love us Section End -->

<!-- Our News & Article Section Start -->
<section id="news-article-pannel">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h2 class="h2">Our <span>News & Articles</span></h2>
        <div class="na-slider-wrapper">
          <div class="na-slides">
            <figure style="background-image: url('assets/img/startup.png')"></figure>
            <!-- <img id="home-startup-img" src="assets/img/startup.png" /> -->
            <div class="na-content certification-text">
              <h4>Startup India Certification</h4>
              <!-- <p class="a-date">12 Mar 2021</p> -->
              <p>Infinity Learn is officially now certified under the Start-up India, a flagship initiative of the
                Government of India.
                Start-up India is intended to build a strong ecosystem that is conducive for the growth of start-up
                businesses, to drive sustainable economic growth and generate large scale employment opportunities.
              </p>
              <!-- <a href="javascript:void(0)" class="btn-arrow"></a> -->
            </div>
          </div>
          <div class="na-slides">
            <figure style="background-image: url('assets/img/sushma-img.png')"></figure>
            <div class="na-content">
              <h4>Not Women Empowerment but Equality</h4>
              <!-- <p class="a-date">12 Mar 2021</p> -->
              <p>Gone are the days of calling out for women’s empowerment, today women are empowered and have created
                their stronghold in all facets of life. Now they need to be nurtured and supported in the most unique
                ways. <strong>Infinity Learn</strong> is making a difference in 2021.</p>
              <!-- <a href="javascript:void(0)" class="btn-arrow"></a> -->
            </div>
          </div>
          <div class="na-slides mmtc-logo">
            <figure style="background-image: url('assets/img/mmtc-img.png')"></figure>
            <div class="na-content">
              <h4>Great Gift for Young Aspirants in Nuh, Haryana </h4>
              <!-- <p class="a-date">12 Mar 2021</p> -->
              <p>MMTC PAMP has partnered with us to uplift young and aspiring students in Nuh, Haryana.
                MMTC PAMP announced full scholarships to students who have opted for science as a subject and have
                passed class X and XI this year.</p>
              <!-- <a href="javascript:void(0)" class="btn-arrow"></a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Our News & Article Section End -->

<!-- Footer Start -->
<app-footer></app-footer>
<!-- Footer End -->
